import { useQuery } from '@tanstack/react-query';
import { t } from 'i18next';
import { queryKeys, sdk } from 'utils/query';

const getPasswordPolicy = () => {
  return sdk.users.passwordPolicy();
};

export interface PasswordRequirement {
  re: RegExp;
  label: string;
}

export const useGetPasswordPolicy = () => {
  const { data: policy } = useQuery({
    queryKey: [queryKeys.passwordPolicy],
    queryFn: getPasswordPolicy,
  });

  const requirements: PasswordRequirement[] = [];

  if (policy?.minimumLength) {
    requirements.push({
      re: new RegExp(`.{${policy.minimumLength},}`),
      label: t('passwordPolicy.length', { min: policy.minimumLength }),
    });
  }
  if (policy?.symbolRequired)
    requirements.push({ re: /[$&+,:;=?@#|'<>.^*()%!-]/, label: t('passwordPolicy.symbolRequired') });
  if (policy?.numberRequired) requirements.push({ re: /[0-9]/, label: t('passwordPolicy.numberRequired') });
  if (policy?.upperCaseRequired) requirements.push({ re: /[A-Z]/, label: t('passwordPolicy.upperCaseRequired') });
  if (policy?.lowerCaseRequired) requirements.push({ re: /[a-z]/, label: t('passwordPolicy.lowerCaseRequired') });

  return { policy, requirements };
};
